<template>
  <section class="ct-categories">
    <div class="ct-categories__container container">
      <div
        class="content-type__content"
      >
        <div
          v-if="slice?.Settings?.Title"
          class="content-type__heading heading heading--2"
        >
          {{ slice.Settings.Title }}
        </div>

        <p
          v-if="slice?.Settings?.Description"
          class="content-type__description"
        >
          {{ slice.Settings.Description }}
        </p>

        <VueCarousel
          v-bind="sliderSettings"
          ref="carousel"
        >
          <VueSlide
            v-for="banner in slice?.Banners"
            :key="banner"
          >
            <StrapiCategory
              :category="banner"
              :lazy="index > 0"
              :category-count="slice?.Banners?.length"
              :full-width="slice?.Settings?.SliceWidth?.toLowerCase() === 'full_width'"
              class="ct-categories__category"
            />
          </VueSlide>
          <template #addons>
            <div
              v-if="showNavigation"
              class="carousel__navigation"
            >
              <VueNavigation>
                <template #prev>
                  <IconArrow class="carousel__icon icon icon--arrow icon--arrow-left" />
                </template>
                <template #next>
                  <IconArrow class="carousel__icon icon icon--arrow icon--arrow-right" />
                </template>
              </VueNavigation>
            </div>
          </template>
        </VueCarousel>
      </div>

      <!--  -->
    </div>
  </section>
</template>

<script setup lang="ts">
const props = defineProps({
  slice: {
    type: Object,
    required: true,
  },
  index: {
    type: Number,
    required: true,
  },
  slices: {
    type: Array,
    required: true,
  },
})

const { settings } = useSliderSettings()
const sliderSettings = {
  ...settings,
  itemsToShow: 2.25,
  itemsToScroll: 1,
  dir: 'ltr' as const,
  snapAlign: 'center' as const,
  breakpoints: {
    700: {
      itemsToShow: 4,
      itemsToScroll: 4,
      snapAlign: 'center' as const,
    },
    1024: {
      itemsToShow: 5,
      itemsToScroll: 5,
      snapAlign: 'start' as const,
    },
  },
}

const carousel = ref()
const showNavigation = computed(() => {
  return props.slice?.Banners?.length > carousel.value?.data?.config?.itemsToShow
  // return carousel.value?.data?.slidesCount.value > carousel.value?.data?.config?.itemsToShow
})
</script>

<style>
@import url("~layers/app/assets/css/vue3-carousel-nuxt.css");
@import url("~layers/app/components/Slices/Categories.css");
</style>
